var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.25a.75.75 0 01.743.648L12.75 5v2.25h5.75a.75.75 0 01.102 1.493l-.102.007h-5.75V11a.75.75 0 01-1.493.102L11.25 11V5a.75.75 0 01.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.297 7.25a.75.75 0 01.102 1.493l-.102.007h-.853c-.89 0-1.614.657-1.688 1.486l-.006.139v14.25c0 .846.677 1.547 1.548 1.619l.146.006h17.112c.89 0 1.614-.657 1.688-1.485l.006-.14v-14.25c0-.846-.677-1.547-1.548-1.619l-.146-.006H22.75V11a.75.75 0 01-1.493.102L21.25 11V5a.75.75 0 011.493-.102L22.75 5v2.25h1.806c1.698 0 3.095 1.3 3.189 2.947l.005.178v14.25c0 1.671-1.338 3.028-3.014 3.12l-.18.005H7.444c-1.698 0-3.095-1.3-3.189-2.947l-.005-.178v-14.25c0-1.671 1.338-3.028 3.014-3.12l.18-.005h.853z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.5a1 1 0 100 2 1 1 0 000-2zm3-3a1 1 0 112 0 1 1 0 01-2 0zm-3-1a1 1 0 100 2 1 1 0 000-2zm11 1a1 1 0 112 0 1 1 0 01-2 0zm-3-1a1 1 0 100 2 1 1 0 000-2zm3-3a1 1 0 112 0 1 1 0 01-2 0zm-3-1a1 1 0 100 2 1 1 0 000-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar32);
export default __webpack_public_path__ + "static/media/icon-calendar-32.ae539d24.svg";
export { ForwardRef as ReactComponent };